import { echo } from '@laravel/echo-vue'
import { usePage } from '@inertiajs/vue3'

export const tenantChannel = (name, prefix = null, tenant = null) => {
  tenant = tenant || usePage().props.echo.tenant

  const root = [prefix, tenant].filter(Boolean).join('-')

  const parts = [root, name]

  return parts.filter(Boolean).join('.')
}

export const isInChannel = (channelName, prefix = null) => {
  const name = prefix
    ? prefix + channelName
    : channelName

  return echo().connector.channels[name] !== undefined
}

export const notInChannel = (channelName, prefix = null) => {
  return !isInChannel(channelName, prefix)
}

export const isInPrivateChannel = (channelName) => {
  return isInChannel(channelName, 'private-')
}

export const notInPrivateChannel = (channelName) => {
  return notInChannel(channelName, 'private-')
}

export const isInPresenceChannel = (channelName) => {
  return isInChannel(channelName, 'presence-')
}

export const notInPresenceChannel = (channelName) => {
  return notInChannel(channelName, 'presence-')
}

export const userChannel = () => {
  return tenantChannel(`user.${usePage().props.auth.user.id}`)
}

export const auctionChannel = (id) => {
  return tenantChannel(`auction.${id}`)
}

export const liveEventChannel = (id) => {
  return tenantChannel(`live-event.${id}`)
}
